"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var get_or_1 = require("get-or");
var distance_1 = require("../common/distance");
var raceType_1 = require("../common/raceType");
var pace_1 = require("../common/pace");
var time_1 = require("../common/time");
var raceType_2 = require("../common/raceType");
var calendarTime_1 = require("../common/calendarTime");
var IntervalType;
(function (IntervalType) {
    IntervalType["SPLIT"] = "split";
    IntervalType["COURSE"] = "course";
    IntervalType["UNDEFINED"] = "undefined";
})(IntervalType = exports.IntervalType || (exports.IntervalType = {}));
var IntervalResult = /** @class */ (function (_super) {
    __extends(IntervalResult, _super);
    function IntervalResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.config = {
            optionalPartialConfig: {
                gunTime: {
                    getter: get_or_1.objectOr,
                    decorators: function (time) {
                        return time_1.Time.build({ json: time });
                    }
                },
                chipTime: {
                    getter: get_or_1.objectOr,
                    decorators: function (time) {
                        return time_1.Time.build({ json: time });
                    }
                }
            }
        };
        _this.brackets = [];
        _this.crossingDateTimeInMilliseconds = 0;
        _this.mostRecentInterval = false;
        _this.pace = new pace_1.Pace();
        _this.chipTime = new time_1.Time();
        _this.gunTime = new time_1.Time();
        _this.timeWithPenalties = new time_1.Time();
        _this.distance = new distance_1.Distance();
        _this.intervalFull = false;
        _this.intervalId = 0;
        _this.intervalName = '';
        _this.intervalOrder = 0;
        _this.intervalRaceType = raceType_1.IntervalRaceType.UNDEFINED;
        _this.intervalType = IntervalType.UNDEFINED;
        return _this;
    }
    return IntervalResult;
}(get_or_1.Transerializable));
exports.IntervalResult = IntervalResult;
var BracketResult = /** @class */ (function (_super) {
    __extends(BracketResult, _super);
    function BracketResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.bracketName = '';
        _this.bracketOrder = 0;
        _this.bracketPublishResults = false;
        _this.bracketRankType = raceType_2.RaceTimeType.CHIP;
        _this.bracketTag = '';
        _this.bracketType = '';
        _this.id = 0;
        _this.isPrimary = false;
        _this.rank = 0;
        _this.totalAthletes = 0;
        return _this;
    }
    return BracketResult;
}(get_or_1.Transerializable));
exports.BracketResult = BracketResult;
var IndividualResult = /** @class */ (function (_super) {
    __extends(IndividualResult, _super);
    function IndividualResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.config = {
            optionalPartialConfig: {
                intervals: {
                    getter: get_or_1.arrayOr,
                    decorators: function (ir) {
                        return IntervalResult.build({ json: ir });
                    }
                }
            }
        };
        _this.age = 0;
        _this.courseId = 0;
        _this.eventCourseId = 0;
        _this.eventId = 0;
        _this.bib = '';
        _this.country = '';
        _this.displayName = '';
        _this.entryStatus = '';
        _this.entryType = '';
        _this.entryId = 0;
        _this.eventStartTime = new calendarTime_1.CalendarTime();
        _this.eventTimeZone = '';
        _this.firstName = '';
        _this.gender = '';
        _this.intervals = [];
        _this.isProfilePublic = false;
        _this.isValidEmail = false;
        _this.lastName = '';
        _this.locality = '';
        _this.raceId = 0;
        _this.raceStartTime = new calendarTime_1.CalendarTime();
        _this.racerId = 0;
        _this.raceName = '';
        _this.overallBracketRaceRankType = raceType_2.RaceTimeType.UNDEFINED;
        _this.racerHasFinished = false;
        _this.racerStartTime = new calendarTime_1.CalendarTime();
        _this.region = '';
        _this.regionId = '';
        _this.thirdPartyEventCourseId = 0;
        _this.thirdPartyEntryId = 0;
        return _this;
    }
    return IndividualResult;
}(get_or_1.Transerializable));
exports.IndividualResult = IndividualResult;
//# sourceMappingURL=irpResultResponse.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-model/dist/models/irpResultResponse.js
 ** module id = 2096
 ** module chunks = 0
 **/